
import React, { useEffect, useState } from "react";
import "react-step-progress/dist/index.css";
import "./routeTracking.css";
import { FILE_BASE_URL } from "../../Services/baseApiUrl";
import { TableLoader } from "../../Common/ShimmerLoader";
import isGHMC from "../../Common/helper/helpar";
function WebView({
    setIsLoadingData,
    isLoadingData,
    routeOptions,
    handleSearchApi
}) {
    const [selectedPointIndex, setSelectedPointIndex] = useState(null);
    const [currentStep, setCurrentStep] = useState(1);
    const [complete, setComplete] = useState(false);
const isProd = isGHMC;
    useEffect(() => {
        if (routeOptions && routeOptions.length > 0) {
            // Select the first collection point when route options are available
            setSelectedPointIndex(routeOptions[0]);
        }
    }, [routeOptions]);

    const handlePointClick = (point) => {
        setSelectedPointIndex(point)
        // console.log("Clicked point:", point);
    };

    const handleRefresh = async () => {
        setIsLoadingData(true);
        try {
            await handleSearchApi();
        } catch (error) {
            console.error('Error refreshing points:', error);
        } finally {
            setIsLoadingData(false);
        }
    };

    return (
        <>
            <div className="flex justify-between d-flex pt-2">
                {isLoadingData ? (
                    <TableLoader height={500} />
                ) : (
                    <>
                        {routeOptions.length === 0 ? (
                            <p className="p-3">Route is Not Deployed</p>
                            // <p>Route is Not Assigned</p>
                        ) : (
                            routeOptions.map((point, i) => {
                                let stepClass = "step-item ";
                                let stepColor = "red";
                                // console.log("Point status:", point.status);
                                if (point.status === 'Completed') {
                                    stepClass += "Completed";
                                    stepColor = "green";
                                } else if (point.status === 'Pending') {
                                    stepClass += "Pending";
                                    stepColor = "gray";
                                }

                                return (
                                    <>
                                        <div
                                            key={i}
                                            className={`${stepClass} ${currentStep === i + 1 && "active"} ${(i + 1 < currentStep || complete) && "complete"}`}
                                            onClick={() => handlePointClick(point)}
                                        >
                                            <div className={`step ${currentStep === i + 1 ? "active" : ""}`} style={{ backgroundColor: stepColor }}>
                                                {i + 1}
                                            </div>
                                        </div>

                                    </>
                                );
                            })
                        )}
                    </>
                )}
            </div>

            <div className="row mt-5">
                <div className="col text-end">
                    <button
                        className={`btn  ${isProd ? "search-ghmc" : "search-swm"}`}
                        onClick={() => handleRefresh()}
                    >
                        Refresh
                    </button>
                </div>
            </div>

            <div className="row mt-5">
                {selectedPointIndex && (
                    <>
                        <div className="col-md-4">
                            {/* <h4>Selected Point Details</h4> */}
                            <h6>Collection Point ID: <b>{selectedPointIndex.collectionPointName}</b></h6>
                            <h6>vehicle Number: <b>{selectedPointIndex.vehicleNumber}</b></h6>
                            {/* <h6>Vehicle Type ID: <b>{selectedPointIndex.vehicleTypeId}</b></h6> */}
                            <h6>Vehicle UID: <b>{selectedPointIndex.vehicleUuid}</b></h6>
                            <h6>Driver Name: <b>{selectedPointIndex.driverName}</b></h6>
                            <h6>Collection Point Latitude: <b>{selectedPointIndex.collectionPointLatitude}</b></h6>
                            <h6>Collection Point Longitude: <b>{selectedPointIndex.collectionPointLogitude}</b></h6>
                            <h6>Collection Point Type: <b>{selectedPointIndex.collectionPointTypeName}</b></h6>
                            <h6>Distance from Collection Point: <b>{selectedPointIndex.distanceFromCollectionPoint}</b></h6>
                            <h6>Route to Collection Points MapId: <b>{selectedPointIndex.routeToCollectionPointsMapId}</b></h6>
                            {/* <h6>Secondary Collection ID: <b>{selectedPointIndex.secondaryCollectionId}</b></h6> */}
                            {/* <h6>Secondary Deployment Attendance ID: <b>{selectedPointIndex.secondaryDeploymentAttendanceId}</b></h6> */}
                            <h6>Sort Order: <b>{selectedPointIndex.sortOrder}</b></h6>
                            {/* <h6>zoneId: <b>{selectedPointIndex.zoneId}</b></h6> */}
                            {/* <h6>wardId: <b>{selectedPointIndex.wardId}</b></h6> */}
                            {/* <h6>circleId: <b>{selectedPointIndex.circleId}</b></h6> */}
                            {/* <h6>shift: <b>{selectedPointIndex.shiftValue}</b></h6> */}
                            <h6>Status: <b>{selectedPointIndex.status}</b></h6>
                        </div>
                        <div className="col-md-4">
                            <h4>Before Image:</h4>
                            <img className="img-fluid"
                                src={selectedPointIndex.beforeImageUrl}
                                // alt={`${selectedPointIndex.collectionPointId}`}
                                alt='No Image'
                                style={{ maxWidth: "100%", maxHeight: '100%' }}
                            />
                            <h6>Date Time: <b>{selectedPointIndex.beforeDateTime}</b></h6>
                            <h6>Latitude: <b>{selectedPointIndex.beforeLatitude}</b></h6>
                            <h6>Longitude: <b>{selectedPointIndex.beforeLongitude}</b></h6>
                        </div>
                        <div className="col-md-4">
                            <h4>After Image:</h4>
                            <img className="img-fluid"
                                src={selectedPointIndex.afterImageUrl}
                                // alt={`${selectedPointIndex.collectionPointId}`}
                                alt='No Image'
                                style={{ maxWidth: "100%", maxHeight: '100%' }}
                            />
                            <h6>Date Time: <b>{selectedPointIndex.afterDateTime}</b></h6>
                            <h6>Latitude: <b>{selectedPointIndex.afterLatitude}</b></h6>
                            <h6>Longitude: <b>{selectedPointIndex.afterLongitude}</b></h6>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export default WebView;
